import { Bus, Car, Clock } from "lucide-react";

export const STEP_TYPES = {
  BUS: "bus-transport",
  CAR: "car",
  WAIT: "wait",
};

export const STEP_CONFIG = {
  [STEP_TYPES.BUS]: {
    label: "Bussi",
    icon: Bus,
    color: "primary",
  },
  [STEP_TYPES.CAR]: {
    label: "Auto",
    icon: Car,
    color: "warning",
  },
  [STEP_TYPES.WAIT]: {
    label: "Bussinvaihto",
    icon: Clock,
    color: "info",
  },
};

/**
 * Returns the allowed next step types given the current steps array.
 * WAIT always auto-appends a BUS, so after WAIT we offer nothing manually.
 */
export const getNextStepOptions = (steps) => {
  if (steps.length === 0) return [STEP_TYPES.BUS, STEP_TYPES.CAR];
  const lastStep = steps[steps.length - 1];
  switch (lastStep.type) {
    case STEP_TYPES.BUS:  return [STEP_TYPES.WAIT, STEP_TYPES.CAR];
    case STEP_TYPES.WAIT: return []; // next bus is auto-appended
    case STEP_TYPES.CAR:  return [STEP_TYPES.BUS];
    default:              return [STEP_TYPES.BUS, STEP_TYPES.CAR];
  }
};

/** Same logic but accepts a single type instead of the full array. */
export const getAllowedNextTypesFor = (type) => {
  switch (type) {
    case STEP_TYPES.BUS:  return [STEP_TYPES.WAIT, STEP_TYPES.CAR];
    case STEP_TYPES.WAIT: return [STEP_TYPES.BUS];
    case STEP_TYPES.CAR:  return [STEP_TYPES.BUS];
    default:              return [STEP_TYPES.BUS, STEP_TYPES.CAR];
  }
};